import { AlertEnum } from '../enums';
import { AxiosError } from 'axios';
import { useAlert } from '.';
import { useTranslation } from 'react-i18next';

const useErrorHandler = () => {
  const { t } = useTranslation();
  const { createAlert, createAlerts } = useAlert();

  return (errors: AxiosError<any>, defaultMessage?: string) => {
    if (errors.response) {
      switch (errors.response.status) {
        case 400:
          createAlert(t('erro.requisicao_invalida'), AlertEnum.ERROR);
          break;
        case 422:
        case 423:
          createAlerts(errors.response.data.errors, AlertEnum.ERROR);
          break;
        default:
          createAlert(defaultMessage ? defaultMessage : errors.message, AlertEnum.ERROR);
      }
    } else {
      createAlert(defaultMessage ? defaultMessage : errors.message, AlertEnum.ERROR);
    }
  };
};

export default useErrorHandler;
